module.exports = __webpack_public_path__ + "static/media/Workover.31c26f46.png";